export const BASE_CONTROL_BAR_HEIGHT_PX = 34;
export const DEFAULT_BUTTON_HEIGHT_PX = BASE_CONTROL_BAR_HEIGHT_PX;
export const DEFAULT_BUTTON_WIDTH_PX = 40;
export const DEFAULT_DIALOG_MENU_ITEM_FONT_SIZE_PX = 14;
export const DEFAULT_BUTTON_MARGIN_RIGHT_PX = 10;
export const DEFAULT_MENU_ITEM_HEIGHT_PX = 40;
